import styled from 'styled-components';
import { Form } from 'formik';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

import { typographyVariant } from 'core/styles';
import { DrawerWrapper } from 'containers/Tasks/components/ActionsSchedulesTable/ScheduleDrawer/styles';

export const StyledFullHeightDrawer = styled(DrawerWrapper)`
  height: 100%;
`;

export const StyledFieldStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  width: 100%;
`;

export const StyledEvidenceHint = styled.p`
  ${typographyVariant('caption')};
  margin: 0;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const StyledEvidenceAnswer = styled.p`
  ${typographyVariant('body2')};
  margin: 0;
  color: ${({ theme }) => theme.palette.text.primary};
  white-space: pre-wrap;
`;

export const StyledRiskLinks = styled.span`
  display: flex;
  flex-direction: column;
`;

export const StyledInfoIcon = styled(InfoOutlineIcon)`
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const StyledSubmitWrapper = styled.span`
  flex: 1;
`;

export const StyledEvidenceFormLayout = styled(Form)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;
